import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import utc from "dayjs/plugin/utc"
import weekday from "dayjs/plugin/weekday"

// Load plugins
dayjs.extend(customParseFormat)
dayjs.extend(weekday)
dayjs.extend(utc)

export default dayjs
